import React, { useEffect, useState } from 'react';
import { PagingQuery, Button } from 'tea-component';
import Filter from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/Sizer/DigitalRevenueDetailFilter';
import { useIntl, connect } from 'umi';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { updateDefaultTimeParams } from '@/pages/intelligence/pages/TopCharts/_config/detailDefaltfilterTime';
import TrendsCard from './TrendsCard';
import GamesCard from './GamesCard';
import CountriesCard from './CountriesCard';
import {
  getDigitalRevenueGamesData,
  getDigitalRevenueCountryData,
  getDigitalRevenueTrendData,
} from './_utils';
import { useCompanyOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useCompanyOptionList';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { changeTimetoDay } from '@/pages/intelligence/utils/topchartsUtils';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import DetailDownload from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/DetailDownload';
import { getCountriesExtendParams } from '@intelligence/utils/filterUtils';
import { getDeviceConfig } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import { COMBINEID_REG } from '@intelligence/utils/constant';

const GamesStatsDigitalRevenue = (porps: any) => {
  const {
    tabId,
    filterState,
    companyId,
    entityType,
    regionsCountries,
    gameName,
    setMainLoading,
    mainLoading,
    setDownloadParamsNormal,
    downloadParamsNormal,
  } = porps;
  const deviceDefVales = getDeviceConfig('DigitalRevenue', entityType)?.value;
  const deviceOptions = getDeviceConfig('DigitalRevenue', entityType)?.options;

  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  const { formatMessage } = useIntl(); // 中英切换方法
  const [trendLineList, setTrendLineList] = useState<any>([]);
  const [trendTableList, setTrendTableList] = useState<any>([]);
  const [trendCardStats, setTrendCardStats] = useState<any>({
    isLoading: true,
    isError: false,
    isNoData: true,
  });
  //   trend标题加上数据聚合方式
  const [trendCountMsg, setTrendCountMsg] = useState({});
  const [gameChartLoading, setGameChartLoading] = useState(true);
  const [gameChartType, setGameChartType] = useState<string>('pie');

  const [gameTableLoading, setGameTableLoading] = useState(false);
  const [countriesChartLoading, setCountriesChartLoading] = useState(true);
  const [countriesChartType, setCountriesChartType] = useState<string>('pie');
  const [gameTotal, setGameTotal] = useState<number>(0);
  const [gameTableList, setGameTableList] = useState<any>([]);
  const [gameLineList, setGameLineList] = useState<any>([]);
  const [gameBarOrPieList, setGameBarOrPieList] = useState<any>([]);
  const [gameCardStats, setGameCardStats] = useState<any>({
    isLoading: true,
    isError: false,
    isNoData: true,
  });
  const [countriesTableLoading, setCountriesTableLoading] = useState(false);
  const [countriesTotal, setCountriesTotal] = useState<number>(0);
  const [countriesTableList, setCountriesTableList] = useState<any>([]);
  const [countriesLineList, setCountriesLineList] = useState<any>([]);
  const [countriesBarOrPieList, setCountriesBarOrPieList] = useState<any>([]);
  const [countriesCardStats, setCountriesCardStats] = useState<any>({
    isLoading: true,
    isError: false,
    isNoData: true,
  });
  const { digitalColumnsList, digitalTrendRevenue } = useCompanyOptionList();
  const [regionOptions, setRegionOptions] = useState([]);
  const [filterLoading, setFilterLoading] = useState(true);

  const [fetchParams, setFetchParams] = useState({
    company_id: companyId,
    entity_type: entityType,
    data_sources: ['mscience'],
    order_metric: 'digitalRevenue',
    order: 'desc',
    page: 1,
    page_size: 5,
    region_type: 'market',
    regions: ['us'],
    period: 'month',
    start_date: '',
    end_date: '',
    segment: 'All',
    device: [],
    metrics: ['digitalRevenue', 'units'],
  });

  useEffect(() => {
    if (companyId && !filterLoading) {
      let newFetchParams = {
        ...fetchParams,
      };
      if (isOperateDetail === true) {
        /** 获取继承参数 */
        const extendParams = getExtendParams();
        newFetchParams = { ...newFetchParams, ...extendParams };
      }
      setFetchParams(newFetchParams);
      getPageData(newFetchParams);
    }
  }, [companyId, filterLoading]);

  const formatRegionParams = (markets: string[]) => {
    // 不同国家国家取交集,并且把交集的结果重新赋值到继承值中
    const { regionValues, filterExtendValue } = getCountriesExtendParams({
      regionOptions, // 国家筛选器options,
      defalutMarket: ['us'], // 没取到交集用的默认值
      disableNoChina: true,
      markets,
      filterExtend: detailFilterExtend,
    });
    setDetailFilterExtend(filterExtendValue);
    return regionValues;
  };

  const getExtendParams = () => {
    const newFetchParams: any = {};
    const marketExtend = detailFilterExtend[filterKeyMap.REGION];
    const timeExtend = detailFilterExtend[filterKeyMap.RANGE_TIME];
    newFetchParams.period = changeTimetoDay(timeExtend?.granularity);
    newFetchParams.start_date = timeExtend?.start_date || '';
    newFetchParams.end_date = timeExtend?.end_date || '';
    newFetchParams.segment =
      detailFilterExtend[filterKeyMap.DIGITAL_SEGEMENT]?.value || fetchParams.segment;

    if (marketExtend) {
      const regionValues = formatRegionParams(marketExtend?.markets);
      newFetchParams.region_type = regionValues?.regionType;
      newFetchParams.regions = regionValues?.regions;
    }
    return newFetchParams;
  };

  const getTrendCardData = async (params) => {
    setTrendCardStats({
      ...trendCardStats,
      isLoading: true,
    });
    setMainLoading(true);
    setDownloadParamsNormal(params);
    const gameData = await getDigitalRevenueTrendData(params, tabId);
    const { startDate, endDate, cardStats, lineData, tableData, total, trendCoundMsg } = gameData;
    setDownloadParamsNormal({
      ...params,
      start_date: startDate,
      end_date: endDate,
    });
    // setTrendComputeType(trendCoundMsg?.type || '');
    // setTrendCount(trendCoundMsg?.value || 0);

    setTrendCountMsg(trendCoundMsg);

    setTrendCardStats(cardStats);
    setTrendLineList(lineData || []);
    setTrendTableList(tableData || []);
    const updatedFetchParams: any = updateDefaultTimeParams({
      fetchParams: params,
      startDate,
      endDate,
      period: params.period,
      isTwoMonths: false,
    });
    setFetchParams(updatedFetchParams);
    setMainLoading(false);
  };

  const getGamesCardData = async (params) => {
    setGameCardStats({
      ...gameCardStats,
      isLoading: true,
    });
    const gameData = await getDigitalRevenueGamesData(params, tabId);
    const { cardStats, lineData, barOrPieData, tableData, total } = gameData;
    setGameCardStats(cardStats);
    setGameLineList(lineData);
    setGameBarOrPieList(barOrPieData);
    setGameTableList(tableData);
    setGameTotal(total);
  };

  const getCountriesCardData = async (params) => {
    setCountriesCardStats({
      ...countriesCardStats,
      isLoading: true,
    });
    const resData = await getDigitalRevenueCountryData(params, tabId);
    const { cardStats, lineData, barOrPieData, tableData, total } = resData;
    setCountriesCardStats(cardStats);
    setCountriesLineList(lineData);
    setCountriesBarOrPieList(barOrPieData);
    setCountriesTableList(tableData);
    setCountriesTotal(total);
  };

  const getPageData = (params) => {
    // 添加ID校验规则
    if (COMBINEID_REG.test(companyId)) {
      // 返回状态， 折线， 表格，
      // 当筛选器更改时，使用新的筛选条件重新渲染卡片
      getTrendCardData(params);

      getGamesCardData(params);
      getCountriesCardData(params);
    }
  };

  const handleConfirm = (value: any) => {
    const newFetchParams = {
      ...fetchParams,
      regions: value?.regions,
      start_date: value?.start_date,
      end_date: value?.end_date,
      segment: value?.segment,
      period: changeTimetoDay(value?.date_type),
    };
    if (entityType === 'console') {
      newFetchParams.device = value?.device || [];
    }
    getPageData(newFetchParams);
  };

  const onGameTableSortChage = async (e: SortByItemType) => {
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric: e?.ratioType === 1 ? `${e?.sortMetric}_ratio` : e?.sortMetric,
    };
    setGameTableList([]);
    setGameTableLoading(true);
    const gameData = await getDigitalRevenueGamesData(newFetchParams, tabId);
    const { tableData } = gameData;
    setGameTableList(tableData);
    setGameTableLoading(false);
  };

  const onGameTablePagingChange = async (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || 5,
    };
    setGameTableList([]);
    setGameTableLoading(true);
    const gameData = await getDigitalRevenueGamesData(newFetchParams, tabId);
    const { tableData } = gameData;
    setGameTableList(tableData);
    setGameTableLoading(false);
  };

  const onCountriesTableSortChage = async (e: SortByItemType) => {
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric: e?.ratioType === 1 ? `${e?.sortMetric}_ratio` : e?.sortMetric,
    };
    setCountriesTableList([]);
    setCountriesTableLoading(true);
    const resData = await getDigitalRevenueCountryData(newFetchParams, tabId);
    const { tableData } = resData;
    setCountriesTableList(tableData);
    setCountriesTableLoading(false);
  };

  const onCountriesTablePagingChange = async (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || 5,
    };
    setCountriesTableList([]);
    setCountriesTableLoading(true);
    const resData = await getDigitalRevenueCountryData(newFetchParams, tabId);
    const { tableData } = resData;
    setCountriesTableList(tableData);
    setCountriesTableLoading(false);
  };

  const changeTrendSegement = (value: string) => {
    // console.log(value);
    // const newFetchParams = {
    //   ...fetchParams,
    //   order_metric: value,
    // };
    // getTrendCardData(newFetchParams);
  };
  const changeEditionSegement = (value: string) => {
    // console.log(value);
    const newFetchParams = {
      ...fetchParams,
      order_metric: value,
    };
    getGamesCardData(newFetchParams);
  };
  const changeMarketSegement = (value: string) => {
    // console.log(value);
    const newFetchParams = {
      ...fetchParams,
      order_metric: value,
    };
    getCountriesCardData(newFetchParams);
  };

  const onFilterInit = (params: any) => {
    const { loading, regionOptions } = params || {};
    setFilterLoading(loading);
    setRegionOptions(regionOptions);
  };

  return (
    <>
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          <Filter
            isTopCompanies
            entityType={entityType}
            timeFilterValues={{
              type: fetchParams.period,
              value: [fetchParams.start_date, fetchParams.end_date],
            }}
            defaultSegementVal={'All'}
            defaultMarket={['global']}
            buttonLogConfig={{}}
            filterConfirm={handleConfirm}
            filterReset={() => {}}
            filterInit={() => {}}
            onFilterInit={onFilterInit}
            deviceDefVales={deviceDefVales}
            deviceOptions={deviceOptions}
          />
          <TipContext
            AWidth={260}
            className="statsfilter-warp-filter-tip"
            tipText={formatMessage({ id: `dbi_mscience_info` })}
          />
        </div>
        <div className="dbi-statsfilter-warp-right">
          <DetailDownload
            entityType={entityType}
            mainLoading={mainLoading}
            downloadParamsNormal={downloadParamsNormal}
            gameName={gameName}
            segpaVa={entityType}
            segment={'digitalRevenue'}
          />
        </div>
      </div>
      <TrendsCard
        lineData={trendLineList}
        tableData={trendTableList}
        dateType={fetchParams?.period}
        cardStatus={trendCardStats}
        trendCountMsg={trendCountMsg}
        pageSortAttr={{
          currentSortValue: fetchParams?.order,
          currentSortMetric: fetchParams?.order_metric,
          currentRatioType: 0,
        }}
        segmentList={digitalTrendRevenue}
        changeSegement={changeTrendSegement}
        entityType={entityType}
        setChartLoading={setGameChartLoading}
        chartLoading={gameChartLoading}
        tabId={tabId}
      />
      <GamesCard
        lineData={gameLineList}
        tableData={gameTableList}
        barOrPieList={gameBarOrPieList}
        dateType={fetchParams?.period}
        startDate={fetchParams?.start_date}
        endDate={fetchParams?.end_date}
        cardStatus={gameCardStats}
        tableTotal={gameTotal}
        segmentList={digitalTrendRevenue}
        tableLoading={gameTableLoading}
        onTableSortChage={onGameTableSortChage}
        onTablePagingChange={onGameTablePagingChange}
        changeSegement={changeEditionSegement}
        entityType={entityType}
        setChartLoading={setGameChartLoading}
        chartLoading={gameChartLoading}
        tabId={tabId}
        chartType={gameChartType}
        setChartType={setGameChartType}
        gameName={gameName}
      />

      <CountriesCard
        lineData={countriesLineList}
        tableData={countriesTableList}
        barOrPieList={countriesBarOrPieList}
        dateType={fetchParams?.period}
        startDate={fetchParams?.start_date}
        endDate={fetchParams?.end_date}
        cardStatus={countriesCardStats}
        tableTotal={countriesTotal}
        segmentList={digitalTrendRevenue}
        tableLoading={countriesTableLoading}
        onTableSortChage={onCountriesTableSortChage}
        onTablePagingChange={onCountriesTablePagingChange}
        changeSegement={changeMarketSegement}
        entityType={entityType}
        setChartLoading={setCountriesChartLoading}
        chartLoading={countriesChartLoading}
        tabId={tabId}
        chartType={countriesChartType}
        setChartType={setCountriesChartType}
        regionsCountries={regionsCountries}
        gameName={gameName}
      />
    </>
  );
};
export default connect((state: any) => {
  return {
    filterState: state[FILTER_EXTEND_NAMESPACE],
    topchartsState: state[DBI_TOPCHARTS],
  };
})(GamesStatsDigitalRevenue);
